import { ViewLoaderService } from '@addins/core/menus';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Task } from '@models/imported/SagaSchema/Task';
import { List } from '@models/list';
import { AddinView } from '@techwan/ionic-core';
import { Subscription } from 'rxjs';
import { CurrentTaskService } from '../../services/current-task/current-task.service';
import { BreakTask, TasksProviderService } from '../../services/tasks-provider/tasks-provider.service';
import { PlannedMissionDetailsViewComponent } from '../planned-mission-details-view/planned-mission-details-view.component';

@Component({
  selector: 'app-planned-missions-view',
  templateUrl: './planned-missions-view.component.html',
  styleUrls: ['./planned-missions-view.component.scss']
})
@AddinView({
  name: 'PlannedMissionsList',
  description: 'Display Planned missions list'
})
export class PlannedMissionsViewComponent implements OnInit, OnDestroy {
  tasks: List<Task | BreakTask> = new List<Task | BreakTask>();
  private tasksChangeSub: Subscription;

  get myTask(): Task {
    return this.tasksProvider.myTask;
  }

  constructor(
    private tasksProvider: TasksProviderService,
    private viewLoader: ViewLoaderService,
    private currentTask: CurrentTaskService
  ) {}

  ngOnInit() {
    this.tasksChangeSub = this.tasksProvider.tasks.onRefresh.subscribe(() => this.initTasks());
    this.initTasks();
  }

  private initTasks() {
    const tasksWithBreaks: (Task | BreakTask)[] = [...this.tasksProvider.tasks.items];
    this.tasks.source = tasksWithBreaks.concat(this.tasksProvider.breakTasks);
    this.tasks.addSort((a, b) => a.StartDateUTC.getTime() - b.StartDateUTC.getTime());
  }

  ngOnDestroy() {
    this.tasksChangeSub?.unsubscribe();
    delete this.tasks;
  }

  openTaskDetails(selectedTask: Task) {
    this.currentTask.select(selectedTask);
    this.viewLoader.show(PlannedMissionDetailsViewComponent);
  }
}
